import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import styled from 'styled-components';
import { Menu } from 'antd';
import { useRoutes } from '../../../routes/Context';

const getSelectedKeys = (menuItems, location) => {
  return menuItems.filter((item) => item.match && location.pathname.match(item.match)).map((item) => item.path);
};

const Item = styled.div`
  user-select: none;
`;

const Text = styled.span`
  font-size: 1rem !important;
`;

const MenuIcon = styled.div`
  font-size: 1.1rem !important;
  width: 10px;
`;

const MenuItem = ({ path, icon, text, sider, component, exact, secret, permissions, infoUsuario, ...otherProps }) => {
  return !permissions || (permissions && permissions(infoUsuario)) ? (
    <Item as={Menu.Item} {...otherProps}>
      <Link to={path}>
        {icon && otherProps.level === 1 && <MenuIcon as={icon} />}
        <Text>{text}</Text>
      </Link>
    </Item>
  ) : null;
};

const Title = ({ icon, text }) => (
  <Item>
    <MenuIcon as={icon} />
    <Text>{text}</Text>
  </Item>
);

const SubMenu = ({ icon, text, sider, childs, component, exact, secret, permissions, infoUsuario, ...otherProps }) => {
  return childs.some((item) => !item.permissions || (item.permissions && item.permissions(infoUsuario))) ? (
    <Item as={Menu.SubMenu} title={<Title icon={icon} text={text} />} {...otherProps}>
      {childs.map((child) => (
        <MenuItem key={child.path} {...child} />
      ))}
    </Item>
  ) : null;
};

const MenuComponent = ({ infoUsuario, collapsed }) => {
  const routes = useRoutes();
  const location = useLocation();
  const selectedKeys = getSelectedKeys(routes, location);

  const menuItems = routes.filter((item) => item.sider);
  const siderRoutes = menuItems
    .filter((item) => !item.parent)
    .map((item) => ({
      ...item,
      childs: menuItems.filter((route) => route.parent === item.path),
    }));

  return (
    <Menu mode="inline" selectedKeys={selectedKeys} defaultOpenKeys={collapsed ? [] : selectedKeys} theme="dark">
      {siderRoutes.map((menu) =>
        menu.childs.length > 0 ? (
          <SubMenu key={menu.path} {...menu} infoUsuario={infoUsuario} />
        ) : (
          <MenuItem key={menu.path} {...menu} infoUsuario={infoUsuario} />
        )
      )}
    </Menu>
  );
};

export default MenuComponent;
